/** Token count in the short form of the locale, e.g. "1.81M", "387K", "950". */
export const formatTokenCount = (value: number, locale: string): string =>
  new Intl.NumberFormat(locale, { notation: 'compact', maximumSignificantDigits: 3 }).format(value);
